module.exports = __webpack_public_path__ + "img/SN_END_FLAG.23514031.png";